const BackDropReducer = (state = false, action ) => {
    if(action.type === "UPDATE_BACKDROP"){
        return action.BackDrop 
    }
    return state
}
export default BackDropReducer
